import React, { useState } from 'react';
import '../App.css';
import axios from "axios";

//import axios from "axios";
import { Dropdown, Modal } from 'react-bootstrap';
import Mail_richiesta_dati from "./Ditta_x1_mail_dati";
import Ditta_Form_Base from "./Ditta_form_base";
import Aggiungi_documentazione_attore from "../Funzioni_comuni_pdf_upload.jsx";
import Preparazione_documento_convenzione from "./Ditta_x2_preparazione_documenti";
import Sposta_la_ditta_nel_cestino from "./Ditta_x12_cancellazione.jsx";

import { AiOutlineMenuFold } from 'react-icons/ai';

const Nuova_Ditta_Edit = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [input, setInput] = useState({
        nome: props.ditta.nome,
        PIVA: props.ditta.PIVA,
        email: props.ditta.email
    });


    function handleChange(event) {
        const { name, value } = event.target;
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: value
            }
        })
    }


    return (
        <>
        <div class="d-flex flex-row-reverse">
            <Dropdown>
                <Dropdown.Toggle variant="Light" id="dropdown-basic">
                    Menu  <AiOutlineMenuFold />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Mail_richiesta_dati ditta={props.ditta} tutor={props.tutor}/>
                    <div class="dropdown-divider"></div>
                    <Sposta_la_ditta_nel_cestino ditta={props.ditta} SET_variab_aggiorna={props.SET_variab_aggiorna}/>
                    <Dropdown.Item onClick={handleShow} >Edit Ditta</Dropdown.Item>
                    <Preparazione_documento_convenzione ditta={props.ditta} />
              
                    <div class="dropdown-divider"></div>
                    {/*------------------ AGGIORNARE MONGO QRCODE ---------------------------*/}   

                    <Aggiungi_documentazione_attore attore_tipo={'ditta'} tipologia_documento={'convenzione'} tutor={props.tutor} attore={props.ditta} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo={'ditta'}  tipologia_documento={'sicurezza'} tutor={props.tutor} attore={props.ditta} SET_variab_aggiorna={props.SET_variab_aggiorna} />
              
                </Dropdown.Menu>
            </Dropdown>
        </div>
        <Modal
            show={show}
            size="lg"
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">

                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Ditta_Form_Base id={props.ditta._id} setShow={setShow} />

            </Modal.Body>
        </Modal>
        </>
    )
}

export default Nuova_Ditta_Edit;
